import { Injectable, inject } from '@angular/core';
import { type Observable, map, merge } from 'rxjs';
import { WsClient } from '@shared/ws';
import {
  CardIssuedEventSchema,
  CardOperationFailedEventSchema,
  CardOperationProgressEventSchema,
  CardOperationRefundedEventSchema,
  CardStatusChangedEventSchema,
  CardThreeDsOtpEventSchema,
  CardTopupCompletedEventSchema,
  CardTransactionEventSchema,
  type CardEvent,
} from '../model/card.ws';

@Injectable({ providedIn: 'root' })
export class CardWsEvents {
  private readonly ws = inject(WsClient);

  events(): Observable<CardEvent> {
    return merge<CardEvent[]>(
      this.ws
        .on('card.issued', CardIssuedEventSchema)
        .pipe(map(payload => ({ name: 'card.issued', payload }) as const)),
      this.ws
        .on('card.operation.progress', CardOperationProgressEventSchema)
        .pipe(map(payload => ({ name: 'card.operation.progress', payload }) as const)),
      this.ws
        .on('card.operation.failed', CardOperationFailedEventSchema)
        .pipe(map(payload => ({ name: 'card.operation.failed', payload }) as const)),
      this.ws
        .on('card.topup.completed', CardTopupCompletedEventSchema)
        .pipe(map(payload => ({ name: 'card.topup.completed', payload }) as const)),
      this.ws
        .on('card.operation.refunded', CardOperationRefundedEventSchema)
        .pipe(map(payload => ({ name: 'card.operation.refunded', payload }) as const)),
      this.ws
        .on('card.transaction', CardTransactionEventSchema)
        .pipe(map(payload => ({ name: 'card.transaction', payload }) as const)),
      this.ws
        .on('card.status.changed', CardStatusChangedEventSchema)
        .pipe(map(payload => ({ name: 'card.status.changed', payload }) as const)),
      this.ws
        .on('card.3ds.otp', CardThreeDsOtpEventSchema)
        .pipe(map(payload => ({ name: 'card.3ds.otp', payload }) as const)),
    );
  }
}
